module.exports = __webpack_public_path__ + "img/sweden-neoplasm-female.19be14fe.png";